import angular from 'angular';

import EDocumentsFactory from './EDocumentsFactory';

import COReviewController from './CO-Review/COReviewController';
import HEROCountersignController from './HERO-Countersign/HEROCountersignController';
import POSignController from './PO-Sign/POSignController';
import POSignModalController from './PO-Sign/POSignModalController';
import POSignFactory from './PO-Sign/POSignFactory';


export default angular.module('app.appDetail.walkthrough.startWork', [])
    .controller('COReviewController', COReviewController)
    .controller('HEROCountersignController', HEROCountersignController)
    .controller('POSignController', POSignController)
    .controller('POSignModalController', POSignModalController)
    .factory('EDocumentsFactory', EDocumentsFactory)
    .factory('POSignFactory', POSignFactory)
    .run(($templateCache) => {
        $templateCache.put('app/appDetail/walkthrough/startWork/CO-Review/CO-Review.html', require('./CO-Review/CO-Review.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/startWork/CO-Review/financialSummary.html', require('./CO-Review/financialSummary.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/startWork/CO-Review/financialSummaryLease.html', require('./CO-Review/financialSummaryLease.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/startWork/HERO-Countersign/HERO-Countersign.html', require('./HERO-Countersign/HERO-Countersign.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/startWork/PO-Sign/PO-Email.html', require('./PO-Sign/PO-Email.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/startWork/PO-Sign/PO-Modal.html', require('./PO-Sign/PO-Modal.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/startWork/PO-Sign/PO-Sign.html', require('./PO-Sign/PO-Sign.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/startWork/index.js